<template lang="pug">
  .confirm-status-switch(@click.stop="onSwitch")
    input(type="checkbox" v-model="_value")
    label.switch-label
      span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 未確認/確認済を切り替えるスイッチコンポーネント
 */
@Component
export default class ConfirmStatusSwitch extends Vue {
  /** 親コンポーネントから受け取るスイッチの値 */
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    return;
  }

  /**
   * ### スイッチ切り替え時イベント
   */
  public onSwitch(): void {
    this.$emit("onSwitch", this.value);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/mobile/_colors.scss";

// ボタン領域
.confirm-status-switch {
  line-height: 26px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 68px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 28px;
    border: 2px solid $font-strong;
    border-radius: 4px;
    font-size: 11px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $switch-border;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "未確認";
    padding: 0 0 0 20px;
    color: $font-strong;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "確認済";
    padding: 0 20px 0 0;
    color: $switch-border;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 20px;
    height: 20px;
    background: $font-strong;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    transition: 0.2s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(40px);
    background: $switch-border;
  }
}
</style>
